import axios from "axios";
import Config from "@/config"

export default class ReportService {
  // getList(accesstoken) {
  //   const options = {
  //     headers: { ...Config.headers(accesstoken), ...{} }
  //   };
  //   return axios
  //     .get(
  //       Config.proxy + Config.url("appliance") + "/factory/installation/list",
  //       options
  //     )
  //     .then(res => res.data);
  // }
  // get(accesstoken, reportId) {
  //   const options = {
  //     headers: { ...Config.headers(accesstoken), ...{} }
  //   };
  //   return axios
  //     .get(
  //       Config.proxy + Config.url("appliance") + "/factory/installation/" + reportId,
  //       options
  //     )
  //     .then(res => res.data);
  // }
  download(accesstoken, reportId, lang) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/" + reportId + "?type=pdf&language="+lang,
        options
      )
      .then(res => res);
  }
  models(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/models",
        options
      )
      .then(res => res.data.body);
  }
  create(accesstoken, report) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/report?complete=false&draft=true", report,
        options
      )
      .then(res => res.data);
  }
  update(accesstoken, reportId, report, complete) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/factory/installation/report/" + reportId + "?complete=" + complete, report,
        options
      )
      .then(res => res.data);
  }
  submit(accesstoken, reportId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/report/" + reportId + "/submit", null,
        options
      )
      .then(res => res.data);
  }
  review(accesstoken, reportId, action) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .put(
        Config.proxy + Config.url("appliance") + "/factory/installation/report/" + reportId + "/review", { action: action },
        options
      )
      .then(res => res.data);
  }
  uploadSignature(accesstoken, reportId, base64Image) {

    // Split into two parts
    const parts = base64Image.split(';base64,');
    // Hold the content type
    const imageType = parts[0].split(':')[1];
    // Decode Base64 string
    const decodedData = window.atob(parts[1]);
    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // Return BLOB image after conversion
    let blob = new Blob([uInt8Array], { type: imageType });
    let formData = new FormData();
    formData.append("file", blob);

    const options = {
      headers: { ...Config.headers(accesstoken), ...{'Content-Type':`multipart/form-data`} }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?installationReportId=" + reportId + "&signature=true", formData,
        options
      )
      .then(res => res.data);
  }
  uploadImage(accesstoken, reportId, file) {
    let formData = new FormData();
    formData.append("file", file);
    const options = {
      headers: { ...Config.headers(accesstoken), ...{ 'Content-Type': `multipart/form-data` } }
    };
    return axios
      .post(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?installationReportId=" + reportId + "&signature=false", formData,
        options
      )
      .then(res => res.data);
  }
  getImage(accesstoken, image) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} },
      responseType: 'blob'
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/image?filePath=" + image,
        options
      )
      .then(res => res);
  }
  getListV2(accesstoken, filters, pagination) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    let params = {
      page: pagination?.first / pagination?.rows,
      nRows: pagination?.rows,
      filterAttributes: [],
      orderAttr: "updateTimestamp",
      ascOrDesc: false
    };
    if (filters.modelNumber?.value !== null && filters.modelNumber?.value !== undefined) {
      params.filterAttributes.push({ attribute: "modelNumber", value: filters.modelNumber.value });
    }
    // if (filters.complete?.value !== null && filters.complete?.value !== undefined) {
    //   params.filterAttributes.push({ attribute: "complete", value: filters.complete.value });
    // }
    if (filters.status?.value !== null && filters.status?.value !== undefined) {
      params.filterAttributes.push({ attribute: "status", value: filters.status.value });
    }
    if (filters.global?.value) {
      params.filterAttributes.push({ attribute: "freeSearch", value: filters.global.value });
    }
    return axios
      .post(
        Config.proxy + Config.url("appliance_v2") + "/factory/installation/list",
        params,
        options
      )
      .then(res => res.data);
  }
  getV2(accesstoken, reportId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance_v2") + "/factory/installation/" + reportId,
        options
      )
      .then(res => res.data);
  }
  getInfoBySerialNumber(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("appliance") + "/factory/installation/info/" + serialNumber,
        options
      )
      .then(res => res.data);
  }
  delete(accesstoken, reportId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .delete(
        Config.proxy + Config.url("appliance") + "/factory/installation/report/" + reportId,
        options
      )
      .then(res => res.data);
  }
}
